"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBeforeDrag = void 0;
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit/");
/**
 * Fire global goodstrap event to close overlays before DnD start,
 * sanitization of placeholders in layout is managed by components itself.
 */
var useGlobalGoodstrapEvent = function () {
    return react_1.useCallback(function () {
        sdk_ui_kit_1.handleOnGoodstrapDragEvent();
    }, []);
};
/**
 * This hook provide global goodstrap event to close overlays
 * @internal
 */
exports.useBeforeDrag = function () {
    var fireGlobalEvent = useGlobalGoodstrapEvent();
    return react_1.useCallback(function () {
        fireGlobalEvent();
    }, [fireGlobalEvent]);
};
//# sourceMappingURL=useBeforeDrag.js.map